export default __webpack_public_path__ + "3608fd7bb45269ee5a07a24511ab1750.png";